import { ColumnMode } from '@swimlane/ngx-datatable';
import { SearchContractorTypesRequest, SearchInspectionsRequest, SearchJurisdictionsRequest, SearchDataEntitiesRequest, SearchInspectionsResponse, SearchJurisdictionsResponse, SearchContractorTypesResponse, SearchDataEntitiesResponse, SearchContractorsRequest, SearchContractorsResponse } from './../../models/test-modules';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { map, Observable, tap, Subject } from 'rxjs';
import { Client, ContractorType, InspectionVM, SearchWorkflowsRequest, SearchWorkflowsResponse, Workflow } from 'src/app/models';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { DataEntity } from 'src/app/models/data-entities';
import { DataService } from 'src/app/services';

@Component({
    selector: 'wm-testing-dashboard',
    templateUrl: './testing-dashboard.component.html',
    styleUrl: './testing-dashboard.component.css',
    standalone: false
})
export class TestingDashboardComponent implements OnInit {
  activityTypes: Activity<ActivityModel>[];
  dataEntityTypes: DataEntity[];
  selectedActivityTypes: string[];
  activityTypeIdx: { [key: string]: Activity<ActivityModel> };
  selectedActivityType: string;

  searchWorkflowRequest: SearchWorkflowsRequest = { page: 1, pageSize: 50 };
  searchJurisdictionsRequest: SearchJurisdictionsRequest = { page: 1, pageSize: 50 };
  searchContractorTypesRequest: SearchContractorTypesRequest = { page: 1, pageSize: 50 };
  searchInspectionsRequest: SearchInspectionsRequest = { status: 1, page: 1, pageSize: 50 };
  searchDataEntitiesRequest: SearchDataEntitiesRequest = { hasCustomLists: true, page: 1, pageSize: 50 };
  searchContractorsRequest: SearchContractorsRequest = { page: 1, pageSize: 50 };

  searchWorkflowsResponse: SearchWorkflowsResponse = new SearchWorkflowsResponse();
  searchJurisdictionsResponse: SearchJurisdictionsResponse = new SearchJurisdictionsResponse();
  searchContractorTypesResponse: SearchContractorTypesResponse = new SearchContractorTypesResponse();
  searchInspectionsResponse: SearchInspectionsResponse = new SearchInspectionsResponse();
  searchContractorsResponse: SearchContractorsResponse = new SearchContractorsResponse();

  ColumnMode = ColumnMode;

  @ViewChild('clientTemp', { static: true })
  private clientTemp: TemplateRef<any>;

  @ViewChild('applicationTemp', { static: true })
  private applicationTemp: TemplateRef<any>;

  @ViewChild('contractorTypeTemp', { static: true })
  private contractorTypeTemp: TemplateRef<any>;

  @ViewChild('contractorTemp', { static: true })
  private contractorTemp: TemplateRef<any>;

  @ViewChild('workflowTemp', { static: true })
  private workflowTemp: TemplateRef<any>;

  @ViewChild('workflowActivityTemp', { static: true })
  private workflowActivityTemp: TemplateRef<any>;

  @ViewChild('applicationActivityTemp', { static: true })
  private applicationActivityTemp: TemplateRef<any>;

  @ViewChild('workflowTemplateCodeTemp', { static: true })
  private workflowTemplateCodeTemp: TemplateRef<any>;

  workflowRows: any[];
  workflowColumns: { prop: string, name: string, cellTemplate?: any }[];

  jurisdictionRows: any[];
  jurisdictionColumns: { prop: string, name: string, cellTemplate?: any }[];

  contractorsColumns: { prop: string, name: string, cellTemplate?: any }[];
  contractorsRows: any[];

  inspectionsColumns: { prop: string, name: string, cellTemplate?: any }[];
  inspectionsRows: any[];

  contractorTypesColumns: { prop: string, name: string, cellTemplate?: any }[];
  contractorTypesRows: any[];

  loading: boolean;

  constructor(private _dataSvc: DataService) { }

  ngOnInit(): void {
    this._dataSvc.getActivityTypes().subscribe(activities => {
      this.activityTypes = activities;
      this.activityTypeIdx = {};
      activities.forEach(a => {
        this.activityTypeIdx[a.type] = a;
      });
    }
    );
    this._dataSvc.getDataEntityTypes().subscribe(dataEntities => this.dataEntityTypes = dataEntities);
    this.workflowColumns = [
      { prop: 'clientName', name: 'Jurisdiction', cellTemplate: this.clientTemp },
      { prop: 'workflowName', name: 'Workflow', cellTemplate: this.workflowTemp },
      { prop: 'activityName', name: 'ActivityName', cellTemplate: this.workflowActivityTemp },
      { prop: 'templateCode', name: 'TemplateCode', cellTemplate: this.workflowTemplateCodeTemp }];

    this.jurisdictionColumns = [
      { prop: 'name', name: 'Jurisdiction', cellTemplate: this.clientTemp }];

    this.contractorsColumns = [
      { prop: 'clientName', name: 'Jurisdiction', cellTemplate: this.clientTemp },
      { prop: 'contractorTypeName', name: 'Contractor Type', cellTemplate: this.contractorTypeTemp },
      { prop: 'businessName', name: 'Contractor (Business Name)', cellTemplate: this.contractorTemp },
      { prop: 'requirementLabel', name: 'Requirement Label' },
      { prop: 'requirementTemplateCode', name: 'Requirement Template Code' }
    ];
    this.inspectionsColumns = [
      { prop: 'clientName', name: 'Jurisdiction', cellTemplate: this.clientTemp },
      { prop: 'applicationName', name: 'Application', cellTemplate: this.applicationTemp },
      { prop: 'activityName', name: 'Activity', cellTemplate: this.applicationActivityTemp }
    ];
    this.contractorTypesColumns = [
      { prop: 'clientName', name: 'Jurisdiction', cellTemplate: this.clientTemp },
      { prop: 'contractorTypeName', name: 'Contractor Type', cellTemplate: this.contractorTypeTemp }
    ];
  }

  onWorkflowsPaged(e) {
    this.searchWorkflowRequest.page = e.offset + 1;
    this.searchWorkflows().subscribe();
  }
  searchWorkflowsClicked() {
    this.searchWorkflowRequest.page = 1;
    this.searchWorkflowsResponse.totalRecords = 0;
    this.searchWorkflows().subscribe();
  }
  clearWorkflowsClicked() {
    this.searchWorkflowRequest = new SearchWorkflowsRequest();
    this.selectedActivityTypes = [];
    this.selectedActivityType = null;
    this.workflowRows = null;
  }

  onJurisdictionsPages(e) {
    this.searchJurisdictionsRequest.page = e.offset + 1;
    this.searchJurisdictions().subscribe();
  }

  searchJurisdictionsClicked() {
    this.searchJurisdictionsRequest.page = 1;
    this.searchJurisdictionsResponse.totalRecords = 0;
    this.searchJurisdictions().subscribe();
  }
  clearJurisdictionsClicked() {
    this.searchJurisdictionsRequest = new SearchJurisdictionsRequest();
    this.jurisdictionRows = null;
  }

  onContractorsPages(e) {
    this.searchContractorsRequest.page = e.offset + 1;
    this.searchContractors().subscribe();
  }

  searchContractorsClicked() {
    this.searchContractorsRequest.page = 1;
    this.searchContractorsResponse.totalRecords = 0;
    this.searchContractors().subscribe();
  }
  clearContractorsClicked() {
    this.searchContractorsRequest = new SearchContractorsRequest();
    this.contractorsRows = null;
  }

  onContractorTypesPages(e) {
    this.searchContractorTypesRequest.page = e.offset + 1;
    this.searchContractorTypes().subscribe();
  }

  searchContractorTypesClicked() {
    this.searchContractorTypesRequest.page = 1;
    this.searchContractorTypesResponse.totalRecords = 0;
    this.searchContractorTypes().subscribe();
  }
  clearContractorTypesClicked() {
    this.searchContractorTypesRequest = new SearchContractorTypesRequest();
    this.contractorTypesRows = null;
  }

  onInspectionsPages(e) {
    this.searchInspectionsRequest.page = e.offset + 1;
    this.searchInspections().subscribe();
  }

  searchInspectionsClicked() {
    this.searchInspectionsRequest.page = 1;
    this.searchInspectionsResponse.totalRecords = 0;
    this.searchInspections().subscribe();
  }
  clearInspectionsClicked() {
    this.searchInspectionsRequest = new SearchInspectionsRequest();
    this.inspectionsRows = null;
  }

  addActivityTypeClicked() {
    if (!this.selectedActivityTypes) {
      this.selectedActivityTypes = [];
    }

    this.searchWorkflowRequest.activityTypes = null;

    const idx = this.selectedActivityTypes.indexOf(this.selectedActivityType);

    if (idx == -1) {
      this.selectedActivityTypes.push(this.selectedActivityType);
    }

    this.selectedActivityType = null;
  }

  removeActivityTypeClicked(at: string) {
    if (this.selectedActivityTypes) {
      const idx = this.selectedActivityTypes.indexOf(at);

      if (idx > -1) {
        this.selectedActivityTypes.splice(idx, 1);
      }
    }
  }

  searchWorkflows(): Observable<SearchWorkflowsResponse> {
    this.loading = true;

    if (!this.searchWorkflowRequest.activityTypes && this.selectedActivityTypes && this.selectedActivityTypes.length > 0) {
      this.searchWorkflowRequest.activityTypes = this.selectedActivityTypes.join(',');
    }

    return this._dataSvc.searchTestingWorkflows(this.searchWorkflowRequest).pipe(tap(r => {
      this.searchWorkflowsResponse = r;
      this.workflowRows = r.workflows;
      this.loading = false;
    }));
  }

  searchContractors() {
    this.loading = true;
    return this._dataSvc.searchTestingContractors(this.searchContractorsRequest).pipe(tap(r => {
      this.searchContractorsResponse = r;
      this.loading = false;
      this.contractorsRows = r.contractors;
    }));
  }

  searchInspections(): Observable<SearchInspectionsResponse> {
    this.loading = true;
    return this._dataSvc.searchTestingInspections(this.searchInspectionsRequest).pipe(tap(r => {
      this.searchInspectionsResponse = r;
      this.loading = false;
      this.inspectionsRows = r.inspections;
    }));
  }

  searchJurisdictions(): Observable<SearchJurisdictionsResponse> {
    this.loading = true;
    return this._dataSvc.searchTestingJurisdictions(this.searchJurisdictionsRequest).pipe(tap(r => {
      this.searchJurisdictionsResponse = r;
      this.jurisdictionRows = r.jurisdictions;
      this.loading = false;
    }));
  }

  searchContractorTypes(): Observable<SearchContractorTypesResponse> {
    this.loading = true;
    return this._dataSvc.searchTestingContractorTypes(this.searchContractorTypesRequest).pipe(tap(r => {
      this.searchContractorTypesResponse = r;
      this.loading = false;
      this.contractorTypesRows = r.contractorTypes;
    }));
  }
}
